<template>
	<div>
		<div
			class="modal fade"
			id="exportClientPopup"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px;top:80px"
				>
					<div class="modal-header" style = "flex: 0 0 auto">
						<h5 class="modal-title" id="exampleModalLongTitle">Export Accounts</h5>
						<button type="button" class="close" data-dismiss="modal" @click = "getClientList">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="margin-top:25px;margin-left:40px;">
						<div class = "form-group row" v-if="!showSpinner">
							<div v-if = "isTimeOut">
								<p>We are processing your request, this may take some time...Please wait</p>
							</div>
							<div v-else>
								<span><a :href = "downloadLink" target="_blank" download>Click here</a> to download the accounts</span>
							</div>
						</div>
                        <div v-else class="spinner-border" style="margin:auto;display:block"></div>
					</div>

					<div class="modal-footer" style = "flex: 0 0 auto">
						<div class="mt-2" style="text-align: center">
							<button type="button" class="btn btn-primary" data-dismiss="modal" @click = "getClientList">Done</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import XLSX from "xlsx";

	export default {
		name: "ExportClientData",
		components: {
		},
		props:["isTimeOut", "downloadLink","showSpinner"],
		mounted() {
		},
		data() {
			return {

			};
		},
		watch: {},
		methods: {
			getClientList(){
				this.$emit("closeExportClientPopUp")
			}
		}
}
</script>
<style lang="scss">
</style>
